module.exports = __webpack_public_path__ + "img/special-event_en.fa8a651.jpg";